import { createServerOnlyContext } from "react-server-only-context";

export const InitialLookupDataContext = createServerOnlyContext(null);
